export default {
  VERSION: '2.0',
};
